import { get } from 'lodash';

import { success, error, loading } from 'State/actions';

import * as types from './types';

export const getTimeZonesAction = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.getGeneric('zones');
      dispatch({
        type: types.GET_TIMEZONES,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.GET_TIMEZONES_ERROR,
        payload: error.response,
      });
    }
  };
};

export const getOffsetMinutes = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.GET_OFFSET_MINUTES_LOADING, true));
      dispatch(error(types.GET_OFFSET_MINUTES_ERROR, null));

      const response = await MPWWebApi.getGeneric('zones/GetOffsetMinutes');
      dispatch(success(types.GET_OFFSET_MINUTES, response.data.Data));
    } catch (err) {
      let errorObj = {
        Message: 'There was an issue retrieving your timezone',
        Title: 'Error',
      };
      if (err.response) {
        const errorFromResponse = get(err, 'response.data.Errors.0');
        if (errorFromResponse) {
          errorObj = errorFromResponse;
        }
      }
      dispatch(error(types.GET_OFFSET_MINUTES_ERROR, errorObj));
    }
    dispatch(loading(types.GET_OFFSET_MINUTES_LOADING, false));
  };
};



// WEBPACK FOOTER //
// ./src/state/timeZones/actions.js